module.exports = __webpack_public_path__ + "img/2_64.5b24b3de.png";